const host = "jinchanhb.com:8500/"
// const host = "zz.zcczcc.com:9528/"
// const host = "127.0.0.1:9527/"
// const host = "192.168.254.3:9527/"
// const host = "192.168.0.11:9527/"

const config = {
  wsUrl: `ws://${host}`,
  baseURL: `http://${host}`
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js